// extracted by mini-css-extract-plugin
export default {"VideosList":"VideoList_VideosList__kHDXT","LoadMore":"VideoList_LoadMore__xDLlZ"};